import React from 'react';
import { Link }  from 'react-router-dom';
import styled  from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints'
import { ChevronRight  } from 'lucide-react';
import LazyVideo from '@/components/landing/common/LazyVideo'

const StyledComp = styled.div`

  margin-bottom: 80px;
  border-bottom: 1px solid rgba(var(--greyr), 0.3);

  @media (max-width: ${breakpoints.medium}) {
    margin-bottom: 80px;
  }

  .header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 40px;
    border-top: 1px solid rgba(var(--greyr), 0.3);
    border-bottom: 1px solid rgba(var(--greyr), 0.3);

    @media (max-width: ${breakpoints.medium}) {
      flex-direction: column;
      align-items: flex-start;
      padding: 20px;
      gap: 10px;
    }

    p{
      font-size: 12px;
      color: var(--grey);
    }
    h3{
      font-size: 32px;

      @media (max-width: ${breakpoints.medium}) {
        font-size: 24px;
      }
    }

  }

  .section{
    padding: 0;
    position: relative;
    height: 80vh;
    overflow: hidden;
    display: flex;
    flex-direction: row;

    @media (max-width: ${breakpoints.large}) {
      flex-direction: column;
      height: auto;
      background-color: rgba(var(--whiter), 0.5);
    }

    .text{
      width: 50%;
      height: 100%;
      padding: 40px;

      @media (max-width: ${breakpoints.large}) {
        width: 100%;
        padding: 20px;
      }
      @media (max-width: ${breakpoints.medium}) {
        width: calc(100% - 40px);
      }

      p{
        width: 50%;
        color: var(--grey);
        padding-bottom: 20px;
        line-height: 1.4;
        font-size: 12px;

        @media (max-width: ${breakpoints.large}) {
          width: 100%;
        }
      }

      a{
        display: inline;
        flex-direction: row;
        vertical-align: middle;
        transition-duration: 0.3s;
        border-radius: 8px;
        padding: 12px 20px;
        background-color: #eee;
        opacity: 0.8;

        svg{
          transition-duration: 0.3s;
          vertical-align: middle;
          padding: 0px;
margin: 0;
          padding-left: 4px;
        }

        &:hover{
          svg{
            transform: translateX(2px);
          }
          opacity: 1;
        }
      }


    }
    .graphic{
      width: 50%;
      hieght: 100%;

      .video-container{
        height: 100%;
      }

      video{
        width: 100%;
        height: 100%;
        opacity: 0.8;
        object-fit: cover;
        filter: invert(1);
      }


      @media (max-width: ${breakpoints.large}) {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100%;
        z-index: -1;
        opacity: 0.5;
        video{
          min-width: 100%;
          min-height: 100%;
        }

      }
    }
  }

  .stats{
      width: 100%;
      border:none;
      padding: 40px 0;

      @media (max-width: ${breakpoints.large}) {
        margin-left: 0;
        padding: 20px;
      }

      p{
        color: var(--grey);
        font-size: 12px;
        padding: 20px 0;
      }
      h4{
        font-size: 48px;
        padding: 20px 0;

        @media (max-width: ${breakpoints.medium}) {
          font-size: 32px;
        }
      }

  }
`;

const Comp = ({}) => {
  return (
    <StyledComp>

      <div className="header">
        <h2 className="serif"> Why This Financial Data Platform Exists</h2>
        <p className="sans"> INFORMATION SHOULDN'T BE A LUXURY </p>
      </div>
      <div className="section">
        <div className="text">
          <p> The market moves fast. Your intelligence needs to move faster. </p>
          <p> We built AxionQuant so you never miss a shift, an opportunity, a warning sign, or a trend ever again. One financial data API for market data, fundamentals, and alternative data. </p>

          <div className="stats">
            <div className="stat">
              <h3 className="serif"> 88% </h3>
              <p> Of quants and analysts report faster research cycles with Axion. </p>
            </div>

            <div className="stat">
              <h3 className="serif"> 34% </h3>
              <p> Average increase in market awareness after integrating alternative data. </p>
            </div>

            <div className="stat">
              <h3 className="serif"> 78% </h3>
              <p>Of professional users rely on Axion's up-to-date data for research decisions. </p>
            </div>
          </div>

          <Link to='/about'>
            More about Axion
            <ChevronRight width={14}/>
          </Link>

        </div>

        <div className="graphic">
          <LazyVideo
            classNames={`video fade-in`}
            src={'https://cdn.studio14a.com/axion/blackdith.mp4'}
          />
        </div>
      </div>

    </StyledComp>
  );
};

export default Comp;
